import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  queryBuilderBarContainer: {},
  queryBuilderBar: {
    padding: theme.spacing(0.375, 0.5),
    minHeight: '2rem',
    border: `1px solid ${theme.vars.palette.border.main}`,
    borderRadius: `${theme.shape.borderRadius}px`,
    backgroundColor: 'transparent',
    '&.withTimeFilter': {
      borderRadius: `0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0`
    }
  },
  queryBuilderRoot: {
    display: 'inline-flex',
    minWidth: '12rem',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    padding: theme.spacing(0, 0.75),
    borderRadius: `${theme.shape.borderRadius}px`,
    backgroundColor: theme.vars.palette.action.selected,
    whiteSpace: 'nowrap',
    boxShadow: `inset 0 0 0 1px ${theme.vars.palette.border.light}`,
    flexShrink: 0,
    '&.qb-start': {
      boxShadow: 'none',
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      paddingLeft: theme.spacing(0),
      flex: '1 1 100%'
    }
  },
  queryBuilderFieldAutocomplete: {
    '.MuiInputBase-root': {
      height: 'auto !important',
      minHeight: '1.25rem !important',
      padding: `${theme.spacing(0.25, 1, 0.25, 0)} !important`
    },
    fieldset: {
      border: 'none'
    }
  },
  queryBuilderField: {
    fontSize: '0.75rem',
    fontWeight: 500
  },
  queryBuilderSelect: {
    height: 'auto !important',
    backgroundColor: theme.vars.palette.transparent.a5,
    fieldset: {
      border: 'none',
      boxShadow: `inset 0 0 0 1px ${theme.vars.palette.border.light}`
    },
    '.MuiSelect-select': {
      padding: theme.spacing(0.25, 1),
      fontFamily: 'monospace',
      fontWeight: 800,
      fontSize: '0.75rem',
      lineHeight: '1.2rem'
    }
  },
  queryBuilderValueDatetime: {
    '.MuiInputBase-root': {
      height: 'auto !important',
      lineHeight: '1rem !important',
      paddingRight: theme.spacing(1),
      width: '11rem',
      minHeight: '1.5rem'
    },
    '.MuiInputAdornment-root': {
      marginLeft: 0,
      height: '1rem'
    },
    '.MuiInputBase-input': {
      padding: `${theme.spacing(0, 1)} !important`
    },
    '.MuiSvgIcon-root': {
      fontSize: '1.25rem'
    }
  },
  queryBuilderInput: {
    '.MuiInputBase-root': {
      height: 'auto !important',
      lineHeight: '1rem !important'
    },
    '.MuiInputBase-input ': {
      padding: `${theme.spacing(0.25, 1)} !important`,
      fieldSizing: 'content'
    }
  },
  queryBuilderValue: {
    fontFamily: 'monospace',
    fontSize: '0.75rem',
    fontWeight: 600,
    cursor: 'pointer',
    maxWidth: '12rem',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    padding: theme.spacing(0.125, 0.5, 0, 0.5),
    lineHeight: '1.25rem',
    borderRadius: `${theme.shape.borderRadius}px`,
    '&:hover': {
      backgroundColor: theme.vars.palette.action.hover
    }
  },
  queryBuilderValueSelect: {
    '.SearchableSelect-button': {
      padding: theme.spacing(0, 1),
      minHeight: '1.5rem !important'
    }
  },
  queryBuilderResetIcon: {
    color: theme.vars.palette.text.secondary,
    cursor: 'pointer',
    '&:hover': {
      color: theme.vars.palette.text.primary
    }
  },
  queryBuilderShortcut: {
    padding: theme.spacing(0.25, 0.75),
    display: 'flex',
    alignItems: 'center',
    borderRadius: `${theme.shape.borderRadius}px`,
    backgroundColor: theme.vars.palette.action.hover,
    fontSize: '0.75rem',
    fontFamily: 'monospace',
    fontWeight: 800,
    userSelect: 'none'
  }
}));

export default useStyles;
